export const defaultTheme = { color: 'blue', font: 'rubik' };
export const defaultLayout = {
  containerWidth: 1440
};

const defaultMetadata = { theme: defaultTheme, layout: defaultLayout };

export default defaultMetadata;
